import { IManageCaseForm } from "../Interfaces";

/**
 * @function
 * @description - make the decision if the create button need to be enabled
 * @param {IManageCaseForm} { newCase } - form data values
 * @return {*}  {boolean} - enabling decision
 */
export const isCreateButtonEnabled = ({ newCase }: IManageCaseForm): boolean => newCase;
